import { Tooltip } from '@saucelabs/ds-tooltip';
import { Typography } from '@saucelabs/ds-typography';
import classNames from 'classnames';
import React, { useEffect, useState } from 'react';

export enum ProgressBarColor {
  GREEN = 'GREEN',
  GREEN_LIGHT = 'GREEN_LIGHT',
  ORANGE = 'ORANGE',
  RED = 'RED',
  GRAY = 'GRAY'
}

type Props = {
  data: {
    label: string
    value: number
    color: ProgressBarColor
  }[],
  cntClass?: string,
  defaultColor?: ProgressBarColor,
}

export const ProgresBarStyles: {[key in ProgressBarColor]: {bar: string, text: string}} = {
  GREEN: {
    bar: 'bg-green-400',
    text: 'text-green-400',
  },
  GREEN_LIGHT: {
    bar: 'bg-green-50',
    text: 'text-green-50',
  },
  ORANGE: {
    bar: 'bg-orange-600',
    text: 'text-orange-600',
  },
  RED: {
    bar: 'bg-red-600',
    text: 'text-red-600',
  },
  GRAY: {
    bar: 'bg-gray-300',
    text: 'text-gray-300',
  },
};

const ProgressBar = ({ data, cntClass = 'flex items-center', defaultColor = ProgressBarColor.GREEN_LIGHT }: Props) => {
  const total = data.reduce((result, next) => result + next.value, 0);

  const [isTooltip, setIsTooltip] = useState(false);
  const showTooltip = () => setIsTooltip(true);
  const hideTooltip = () => setIsTooltip(false);

  return (

    <div
      className={classNames('w-24', cntClass)}
      data-qa="build-progress"
      onMouseEnter={showTooltip}
      onMouseLeave={hideTooltip}
    >
      <Tooltip
        isOpen={isTooltip}
        placement="top"
        title={(
          <div>
            {data.map((item) => (
              <Typography
                key={item.label}
                variant="body-small"
              >
                <span className={`mr-1 font-semibold ${ProgresBarStyles[item.color].text}`}>{item.value}</span>
                <span className="font-normal">{item.label}</span>
              </Typography>
            ))}

          </div>
        )}
      >
        <div className="flex flex-grow justify-self-stretch rounded overflow-hidden h-1.5">
          {!total ?
            <div className={`flex flex-grow ${ProgresBarStyles[defaultColor].bar}`} /> :
            data.map((item) => (item.value ? (
              <div
                key={item.label}
                className={`flex ${ProgresBarStyles[item.color].bar}`}
                style={{ width: `${(item.value / total) * 100}%` }}
              />
            ) : null))}
        </div>
      </Tooltip>
    </div>
  );
};

export default ProgressBar;
